/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_VaultInputs */

const en_nav_vault = /** @type {(inputs: Nav_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault`)
};

const id_nav_vault = /** @type {(inputs: Nav_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault`)
};

/** @type {(inputs: Nav_VaultInputs) => LocalizedString} */
const es_nav_vault = en_nav_vault;

/** @type {(inputs: Nav_VaultInputs) => LocalizedString} */
const fr_nav_vault = en_nav_vault;

/** @type {(inputs: Nav_VaultInputs) => LocalizedString} */
const de_nav_vault = en_nav_vault;

/** @type {(inputs: Nav_VaultInputs) => LocalizedString} */
const ja_nav_vault = en_nav_vault;

/** @type {(inputs: Nav_VaultInputs) => LocalizedString} */
const zh_nav_vault = en_nav_vault;

/** @type {(inputs: Nav_VaultInputs) => LocalizedString} */
const ar_nav_vault = en_nav_vault;

/** @type {(inputs: Nav_VaultInputs) => LocalizedString} */
const it_nav_vault = en_nav_vault;

/** @type {(inputs: Nav_VaultInputs) => LocalizedString} */
const ru_nav_vault = en_nav_vault;

/** @type {(inputs: Nav_VaultInputs) => LocalizedString} */
const pt_nav_vault = en_nav_vault;

/** @type {(inputs: Nav_VaultInputs) => LocalizedString} */
const ko_nav_vault = en_nav_vault;

/**
* | output |
* | --- |
* | "Vault" |
*
* @param {Nav_VaultInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_vault = /** @type {((inputs?: Nav_VaultInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_VaultInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_vault(inputs)
	if (locale === "es") return es_nav_vault(inputs)
	if (locale === "fr") return fr_nav_vault(inputs)
	if (locale === "de") return de_nav_vault(inputs)
	if (locale === "ja") return ja_nav_vault(inputs)
	if (locale === "zh") return zh_nav_vault(inputs)
	if (locale === "ar") return ar_nav_vault(inputs)
	if (locale === "id") return id_nav_vault(inputs)
	if (locale === "it") return it_nav_vault(inputs)
	if (locale === "ru") return ru_nav_vault(inputs)
	if (locale === "pt") return pt_nav_vault(inputs)
	return ko_nav_vault(inputs)
});